import * as Cookie from "js-cookie";

export const getAdobeSessionId = () => {
  return Cookie.get("adobe-session-id") || "";
};
